import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import SilenceSmartCut from '@components/Studio/SilenceSmartCut';
import Window from '@components/Window/Window';

const SilenceSmartCutWindow = ({ onClose = () => {}, open = false, media, onSmartCut = () => {}, start = 0, duration = null }) => {
  const { t } = useTranslation();
  const _onSmartCut = useCallback(
    (values) => {
      onSmartCut(values);
      onClose();
    },
    [onClose, onSmartCut]
  );

  return (
    <Window open={open} onClose={onClose} title={t('Smart cut')}>
      <SilenceSmartCut media={media} onSmartCut={_onSmartCut} start={start} duration={duration} />
    </Window>
  );
};

export default SilenceSmartCutWindow;
